import React from 'react';

import PageFooter from './layout/pageFooter.jsx';

import Pagination from './layout/pagination.jsx';

import Loader from './loader.jsx';
import {FormattedMessage} from 'react-intl';

let SearchResults = ({
  baseUrl, items, count, query, pageSize, page, onResultClick,
  onPageChange, onVideoFilterToggle, enableVideoFilter = false, videosOnly = false, formatMessage,
}) => {
  let loaded = !!items;

  return (
    <Loader loaded={loaded}>
      <div className='search-results-container'>
        <p className='search-summary'>
          <strong><FormattedMessage id="encyclopedia.search.returned" /> <span style={{fontSize: '1.2em'}}>{count}</span> <FormattedMessage id="encyclopedia.results.for" /> "{query.trim()}"</strong>
        </p>
        <table className='table-biolab'>
          <thead>
            <tr>
              <th/>
              <th><FormattedMessage id="encyclopedia.article.title" /></th>
              <th><FormattedMessage id="encyclopedia.article.description" /></th>
              {enableVideoFilter ?
                <th>
                  <button className={'btn btn-fade' + (videosOnly ? ' active' : '')} onClick={onVideoFilterToggle} title={formatMessage({id: 'encyclopedia.show.videos.only'})}>
                    <span className='video-icon bl bl-video'/>
                  </button>
                </th> :
                null
              }
            </tr>
          </thead>
          <tbody>
            {(items || []).map((result) =>
              <tr key={result.slug} onClick={() => onResultClick(result)} style={{cursor: 'pointer'}}>
                <td>
                  {result.fav ? <i className='sr-fav star icon bl bl-star-filled' title='Favorite' /> : ' '}
                </td>
                <td>
                  {result.title}
                </td>
                <td>
                  {result.summary}
                </td>
                {enableVideoFilter ? <td>{result.containsVideo ? <div className='btn btn-link'><span className='video-icon bl bl-video' title={formatMessage({id: 'encyclopedia.has.video'})}/>
                </div> : ' '}
                </td> : null}
              </tr>
            )}
            {(() => {
              if ((items || []).length === 0) {
                return (
                  <tr key='-1'>
                    <td colSpan='100%'><i><FormattedMessage id="general.error.nomatches" /></i></td>
                  </tr>
                );
              }
              return <tr key='-1'/>;
            })()}
          </tbody>
        </table>

        <PageFooter className='tc'>
          <Pagination baseUrl={baseUrl} page={page} count={pageSize} total={count} onPageChange={onPageChange} />
        </PageFooter>
      </div>
    </Loader>
  );
};

export default SearchResults;
